<!-- 订单列表 -->
<template>
  <div id="kt_post" class="post flex-column-fluid">
    <!--    顶部标题-->
    <TitleCard v-if="!params.wxShopId" style="margin: 10px auto; max-width: 97%" title="用户管理">
      <template v-slot:subTitle>
        <ul class="breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1">
          <li class="breadcrumb-item text-muted">User Management</li>
        </ul>
      </template>
    </TitleCard>
    <div
        class="container-fluid d-flex flex-stack flex-column-fluid"
        style="padding: 0 30px"
    >
      <form action="#" style="width: 100%">
        <!--begin::Card-->
        <div class="card">
          <!--begin::Card body-->
          <div class="card-body">
            <!--begin::Compact form-->
            <div class="d-flex align-items-center">
              <!--begin::Input group-->
              <div class="position-relative w-md-400px me-md-2">
                <span
                    class="svg-icon svg-icon-3 svg-icon-gray-500 position-absolute top-50 translate-middle ms-6"
                >
                  <svg
                      height="24px"
                      version="1.1"
                      viewBox="0 0 24 24"
                      width="24px"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <g
                        fill="none"
                        fill-rule="evenodd"
                        stroke="none"
                        stroke-width="1"
                    >
                      <rect height="24" width="24" x="0" y="0"></rect>
                      <path
                          d="M14.2928932,16.7071068 C13.9023689,16.3165825 13.9023689,15.6834175 14.2928932,15.2928932 C14.6834175,14.9023689 15.3165825,14.9023689 15.7071068,15.2928932 L19.7071068,19.2928932 C20.0976311,19.6834175 20.0976311,20.3165825 19.7071068,20.7071068 C19.3165825,21.0976311 18.6834175,21.0976311 18.2928932,20.7071068 L14.2928932,16.7071068 Z"
                          fill="#000000"
                          fill-rule="nonzero"
                          opacity="0.3"
                      ></path>
                      <path
                          d="M11,16 C13.7614237,16 16,13.7614237 16,11 C16,8.23857625 13.7614237,6 11,6 C8.23857625,6 6,8.23857625 6,11 C6,13.7614237 8.23857625,16 11,16 Z M11,18 C7.13400675,18 4,14.8659932 4,11 C4,7.13400675 7.13400675,4 11,4 C14.8659932,4 18,7.13400675 18,11 C18,14.8659932 14.8659932,18 11,18 Z"
                          fill="#000000"
                          fill-rule="nonzero"
                      ></path>
                    </g>
                  </svg>
                </span>
                <!--end::Svg Icon-->
                <input
                    id="sTitle"
                    v-model="params.name"
                    class="form-control form-control-solid ps-10"
                    name="shopName"
                    placeholder="用户昵称"
                    type="text"
                    value=""
                />

              </div>
              <!--end::Input group-->

              <!--begin::Input group-->
              <div class="position-relative w-md-400px me-md-2">
                <span
                    class="svg-icon svg-icon-3 svg-icon-gray-500 position-absolute top-50 translate-middle ms-6"
                >
                  <svg
                      height="24px"
                      version="1.1"
                      viewBox="0 0 24 24"
                      width="24px"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <g
                        fill="none"
                        fill-rule="evenodd"
                        stroke="none"
                        stroke-width="1"
                    >
                      <rect height="24" width="24" x="0" y="0"></rect>
                      <path
                          d="M14.2928932,16.7071068 C13.9023689,16.3165825 13.9023689,15.6834175 14.2928932,15.2928932 C14.6834175,14.9023689 15.3165825,14.9023689 15.7071068,15.2928932 L19.7071068,19.2928932 C20.0976311,19.6834175 20.0976311,20.3165825 19.7071068,20.7071068 C19.3165825,21.0976311 18.6834175,21.0976311 18.2928932,20.7071068 L14.2928932,16.7071068 Z"
                          fill="#000000"
                          fill-rule="nonzero"
                          opacity="0.3"
                      ></path>
                      <path
                          d="M11,16 C13.7614237,16 16,13.7614237 16,11 C16,8.23857625 13.7614237,6 11,6 C8.23857625,6 6,8.23857625 6,11 C6,13.7614237 8.23857625,16 11,16 Z M11,18 C7.13400675,18 4,14.8659932 4,11 C4,7.13400675 7.13400675,4 11,4 C14.8659932,4 18,7.13400675 18,11 C18,14.8659932 14.8659932,18 11,18 Z"
                          fill="#000000"
                          fill-rule="nonzero"
                      ></path>
                    </g>
                  </svg>
                </span>
                <!--end::Svg Icon-->
                <input
                    id="sTitle"
                    v-model="params.userId"
                    class="form-control form-control-solid ps-10"
                    name="shopName"
                    placeholder="用户编号"
                    type="text"
                    value=""
                />

              </div>
              <!--end::Input group-->

              <!--begin:Action-->
              <div class="d-flex align-items-center">
                <div class="btn btn-primary me-5 btn-sm" @click="getList">
                  查询
                </div>
                <div class="btn btn-secondary me-5 btn-sm" @click="resetBtn">
                  重置
                </div>
                <a
                    id="kt_horizontal_search_advanced_link"
                    class="btn btn-link"
                    data-bs-toggle="collapse"
                    href="#kt_advanced_search_form"
                >高级查询</a
                >

              </div>

            </div>

            <!--begin::高级搜索-->
            <div id="kt_advanced_search_form" class="collapse">
              <!--begin::Separator-->
              <div class="separator separator-dashed mt-9 mb-6"></div>
              <!--end::Separator-->
              <!--begin::Row-->
              <div class="row g-8 mb-8">
                <!--begin::Col-->
                <div class="col-lg-3">
                  <label class="fs-6 form-label fw-bolder text-dark"
                  >上级编号</label
                  >
                  <br/>
                  <el-input
                      v-model="params.pUserId"
                      clearable
                      placeholder="请输入要查询的上级编号"
                  >
                  </el-input>
                </div>
                <!--end::Col-->
                <!--begin::Col-->
                <div class="col-lg-3">
                  <label class="fs-6 form-label fw-bolder text-dark"
                  >手机号</label
                  >
                  <br/>
                  <el-input
                      v-model="params.tel"
                      clearable
                      placeholder="请输入要查询的手机号"
                  >
                  </el-input>
                </div>
                <!--end::Col-->
                <!--begin::Col-->
                <div class="col-lg-2">
                  <label class="fs-6 form-label fw-bolder text-dark"
                  >会员等级</label
                  >
                  <br/>
                  <el-select v-model="params.level"
                             placeholder="请选择会员等级"
                             style="margin-right: 20px;margin-left: 10px">
                    <el-option
                        :value="1"
                        label="小程序用户">
                    </el-option>
                    <el-option
                        :value="2"
                        label="队长">
                    </el-option>
                    <el-option
                        :value="5"
                        label="总队长">
                    </el-option>
                    <el-option
                        :value="3"
                        label="店长">
                    </el-option>
                    <el-option
                        :value="4"
                        label="老板">
                    </el-option>
                    <el-option
                        :value="-1"
                        label="金牌合伙人">
                    </el-option>
                  </el-select>
                </div>
                <!--end::Col-->
                <!--begin::Col-->
<!--                <div class="col-lg-2">
                  <label class="fs-6 form-label fw-bolder text-dark"
                  >代理等级</label
                  >
                  <br/>
                  <el-select v-model="params.agent"
                             placeholder="请选择代理等级"
                             style="margin-right: 20px;margin-left: 10px">
                    <el-option
                        label="省代"
                        value="1">
                    </el-option>
                    <el-option
                        label="市代"
                        value="2">
                    </el-option>
                    <el-option
                        label="区代"
                        value="3">
                    </el-option>
                  </el-select>
                </div>-->
                <!--end::Col-->
              </div>
              <!--end::Row-->
            </div>
            <!--end::Advance form-->

          </div>
          <!--end::Card body-->
        </div>
        <!--end::Card-->
      </form>
    </div>
    <div
        id="kt_content_container"
        class="container"
        style="
        margin-top: 10px;
        max-width: 98%;
        flex-direction: row !important;
        display: flex;
      "
    >
      <div id="kt_app_main" class="app-main flex-column flex-row-fluid">
        <div class="d-flex flex-column flex-column-fluid">
          <div id="kt_app_content" class="" style="margin-bottom: 10px">
            <!-- {{idArr}} {{ sumMoney }} -->
            <div class="card card-flush" style="position: relative">
              <div class="card-body">
                <div id="myTabContent" class="tab-content">
                  <div
                      v-loading="loading"
                      class="card mb-5 mb-xl-8"
                      element-loading-background="rgba(0, 0, 0, 0.8)"
                      element-loading-spinner="el-icon-loading"
                      element-loading-text="拼命加载中"
                      style="margin-left: 3px; width: 100%"
                  >
                    <div class="card-body py-3">
                      <div class="table-responsive">
                        <table
                            id="kt_ecommerce_products_table"
                            class="table align-middle table-row-dashed table-hover fs-6 gy-5 dataTable no-footer"
                        >
                          <thead>
                          <tr
                              class="text-start text-gray-500 fw-bold fs-7 text-uppercase gs-0"
                          >
                            <th
                                aria-label="order_batch"
                                class="text-center min-w-50px"
                                colspan="1"
                                rowspan="1"
                                style="width: 30px"
                                tabindex="0"
                            >
                              编号
                            </th>
                            <th
                                aria-label="product_name"
                                class="text-center min-w-150px"
                                colspan="1"
                                rowspan="1"
                                style="width: 106.344px"
                                tabindex="0"
                            >
                              昵称
                            </th>
                            <th
                                aria-label="market_price"
                                class="text-center min-w-40px"
                                colspan="1"
                                rowspan="1"
                                style="width: 106.344px"
                                tabindex="0"
                            >
                              手机号
                            </th>
                            <th
                                aria-label="order_time"
                                class="text-center min-w-60px"
                                colspan="1"
                                rowspan="1"
                                style="width: 50px"
                                tabindex="0"
                            >
                              上级编号
                            </th>
<!--                            <th
                                aria-label="order_time"
                                class="text-center min-w-60px"
                                colspan="1"
                                rowspan="1"
                                style="width: 100px"
                                tabindex="0"
                            >
                              积分
                            </th>-->
                            <th
                                aria-label="order_time"
                                class="text-center min-w-60px"
                                colspan="1"
                                rowspan="1"
                                style="width: 100px"
                                tabindex="0"
                            >
                              佣金
                            </th>
<!--                            <th
                                aria-label="order_time"
                                class="text-center min-w-60px"
                                colspan="1"
                                rowspan="1"
                                style="width: 106.344px"
                                tabindex="0"
                            >
                              消费金额
                            </th>
                            <th
                                aria-label="order_time"
                                class="text-center min-w-60px"
                                colspan="1"
                                rowspan="1"
                                style="width: 50px"
                                tabindex="0"
                            >
                              订单总数
                            </th>-->
                            <th
                                aria-label="order_time"
                                class="text-center min-w-60px"
                                colspan="1"
                                rowspan="1"
                                style="width: 106.344px"
                                tabindex="0"
                            >
                              会员等级
                            </th>
                            <th
                                aria-label="order_time"
                                class="text-center min-w-60px"
                                colspan="1"
                                rowspan="1"
                                style="width: 106.344px"
                                tabindex="0"
                            >
                              账号状态
                            </th>
<!--                            <th
                                aria-label="order_time"
                                class="text-center min-w-60px"
                                colspan="1"
                                rowspan="1"
                                style="width: 106.344px"
                                tabindex="0"
                            >
                              代理等级
                            </th>-->
                            <th
                                aria-label="order_time"
                                class="text-center min-w-60px"
                                colspan="1"
                                rowspan="1"
                                style="width: 106.344px"
                                tabindex="0"
                            >
                              注册时间
                            </th>
                            <th
                                aria-label="order_time"
                                class="text-center min-w-60px"
                                colspan="1"
                                rowspan="1"
                                style="width: 150px"
                                tabindex="0"
                            >
                              操作
                            </th>
                          </tr>
                          </thead>
                          <tbody class="fw-semibold text-gray-600">
                          <tr
                              v-for="(item, index) in list"
                              :key="index"
                              :class="{ old: index % 2 == 0, even: index % 2 != 0 }"
                          >

                            <td class="text-center pe-0">
                              <span :title="item.id"
                                    class=""
                                    style="overflow: hidden;
                                  display: -webkit-box;
                                  -webkit-box-orient: vertical;
                                  -webkit-line-clamp: 3;
                                  line-height: 1.2;">{{ item.id }}</span>
                            </td>
                            <!-- 商品名称 -->
                            <td class="text-center pe-0">
                              <span :title="item.name"
                                    class=""
                                    style="overflow: hidden;
                                    display: -webkit-box;
                                    -webkit-box-orient: vertical;
                                    -webkit-line-clamp: 3;
                                    line-height: 1.2;">{{ item.name }}</span>
                            </td>
                            <!-- 市场价 -->
                            <td class="text-center pe-0">
                              <span>{{ item.tel }}</span>
                            </td>

                            <!--下单时间-->
                            <td class="text-center pe-0">
                              <span>{{ item.bindId }}</span>
                            </td>
<!--                            <td class="text-center pe-0">
                              <span>{{ item.score }}</span>
                            </td>-->
                            <!-- 商品名称 -->
                            <td class="text-center pe-0">
                              <span :title="item.commission"
                                    class=""
                                    style="overflow: hidden;
                                    display: -webkit-box;
                                    -webkit-box-orient: vertical;
                                    -webkit-line-clamp: 3;
                                    line-height: 1.2;">{{ item.commission }}</span>
                            </td>
                            <!-- 商品名称 -->
<!--                            <td class="text-center pe-0">
                              <span :title="item.orderTotalMoney"
                                    class=""
                                    style="overflow: hidden;
                                    display: -webkit-box;
                                    -webkit-box-orient: vertical;
                                    -webkit-line-clamp: 3;
                                    line-height: 1.2;">{{ item.orderTotalMoney }}</span>
                            </td>-->
                            <!-- 商品名称 -->
<!--                            <td class="text-center pe-0">
                              <span :title="item.orderCount"
                                    class=""
                                    style="overflow: hidden;
                                    display: -webkit-box;
                                    -webkit-box-orient: vertical;
                                    -webkit-line-clamp: 3;
                                    line-height: 1.2;">{{ item.orderCount }}</span>
                            </td>-->
                            <!-- 会员等级 -->
                            <td class="text-center pe-0">
                              <el-tag
                                  v-if="item.level==1"
                                  effect="info">
                                小程序用户
                              </el-tag>
                              <el-tag
                                  v-if="item.level==2"
                                  type="warning"
                                  effect="dark">
                                队长
                              </el-tag>
                              <el-tag
                                  v-if="item.level==3"
                                  type="success"
                                  effect="dark">
                                店长
                              </el-tag>
                              <el-tag
                                  v-if="item.level==5"
                                  type="danger"
                                  effect="dark">
                                总队长
                              </el-tag>
                              <el-tag
                                  v-if="item.level==4"
                                  type="danger"
                                  effect="dark">
                                老板
                              </el-tag>
                              <el-tag
                                  v-if="item.level==-1"
                                  :hit="false"
                                  color="#CC6CE7"
                                  style="border-color:#CC6CE7"
                                  effect="dark">
                                金牌合伙人
                              </el-tag>

                            </td>
                            <!-- 账号状态 -->
                            <td class="text-center pe-0">
                              <el-tag
                                  v-if="item.status==1"
                                  type="success"
                                  effect="info">
                                正常
                              </el-tag>
                              <el-tag
                                  v-if="item.status==2"
                                  type="danger"
                                  effect="dark">
                                封禁
                              </el-tag>

                            </td>
                            <!-- 代理等级 -->
<!--                            <td class="text-center pe-0">
                              <el-tag
                                  v-if="item.agent==1"
                                  effect="danger">
                                省代
                              </el-tag>
                              <el-tag
                                  v-if="item.agent==2"
                                  effect="success">
                                市代
                              </el-tag>
                              <el-tag
                                  v-if="item.agent==3"
                                  effect="warning">
                                区代
                              </el-tag>
                            </td>-->
                            <!-- 商品名称 -->
                            <td class="text-center pe-0">
                              <span :title="item.crTime"
                                    class=""
                                    style="overflow: hidden;
                                    display: -webkit-box;
                                    -webkit-box-orient: vertical;
                                    -webkit-line-clamp: 3;
                                    line-height: 1.2;">{{ item.crTime }}</span>
                            </td>

                            <td class="text-center">
                              <a
                                  href="#"
                                  class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary"
                                  data-kt-menu-trigger="click"
                                  data-kt-menu-placement="bottom-end"
                                  @click="toggleDropdown(index)"
                              >
                                操作
                                <i class="ki-outline ki-down fs-5 ms-1"></i>
                              </a>
                              <div
                                  :id="'dropdown-' + index"
                                  class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-150px py-4"
                                  data-kt-menu="true"
                              >


<!--                                <div
                                    class="menu-item px-3"
                                    v-if="permissionList.includes('admin.user.editScore')"
                                >
                                  <a
                                      href="javascript:void(0)"
                                      class="menu-link px-3"
                                      @click="handleEditScore(item)"
                                  >修改佣金</a
                                  >
                                </div>

                                <div
                                    class="menu-item px-3"
                                >
                                  <a
                                      href="javascript:void(0)"
                                      class="menu-link px-3"
                                      @click="checkUserScore(item)"
                                  >佣金记录</a
                                  >
                                </div>

                                <div
                                    class="menu-item px-3"
                                    v-if="permissionList.includes('admin.user.editScore')"
                                >
                                  <a
                                      href="javascript:void(0)"
                                      class="menu-link px-3"
                                      @click="handleEdit(item)"
                                  >修改积分</a
                                  >
                                </div>

                                <div
                                    class="menu-item px-3"
                                >
                                  <a
                                      href="javascript:void(0)"
                                      class="menu-link px-3"
                                      @click="checkScore(item)"
                                  >积分记录</a
                                  >
                                </div>-->

                                <div
                                    class="menu-item px-3"
                                    v-if="permissionList.includes('admin.user.editScore')"
                                >
                                  <a
                                      href="javascript:void(0)"
                                      class="menu-link px-3"
                                      @click="editLevel(item)"
                                  >修改等级</a
                                  >
                                </div>
                                <div
                                    class="menu-item px-3"
                                    v-if="permissionList.includes('admin.user.editScore')"
                                >
                                  <a
                                      href="javascript:void(0)"
                                      class="menu-link px-3"
                                      @click="editStatus(item)"
                                  >修改账户状态</a
                                  >
                                </div>

<!--                                <div
                                    class="menu-item px-3"
                                    v-if="permissionList.includes('admin.user.editScore')"
                                >
                                  <a
                                      href="javascript:void(0)"
                                      class="menu-link px-3"
                                      @click="editAgent(item)"
                                  >修改代理</a
                                  >
                                </div>

                                <div
                                    v-if="item.bindId != null &&permissionList.includes('admin.user.editScore')"
                                    class="menu-item px-3"
                                >
                                  <a
                                      class="menu-link px-3"
                                      href="javascript:void(0)"
                                      @click="jiebang(item)"
                                  >解绑</a
                                  >
                                </div>-->


                              </div>
                            </td>

                            <!--                            <td style="text-align: center">
                                                          <el-button
                                                              size="mini"
                                                              @click="handleEditScore(item)" style="margin-left: 8px;">修改佣金
                                                          </el-button>
                                                          <el-button
                                                              size="mini"
                                                              type="primary"
                                                              @click="checkUserScore(item)" style="margin-top: 5px;">佣金记录
                                                          </el-button>
                                                          <el-button
                                                              size="mini"
                                                              @click="handleEdit(item)" style="margin-top: 5px;">修改积分
                                                          </el-button>
                                                          <el-button
                                                              size="mini"
                                                              type="primary"
                                                              @click="checkScore(item)" style="margin-top: 5px;">积分记录
                                                          </el-button>
                                                          <el-button
                                                              size="mini"
                                                              type="success"
                                                              @click="editLevel(item)" style="margin-top: 5px;">修改等级
                                                          </el-button>
                            &lt;!&ndash;                              <el-button
                                                              size="mini"
                                                              type="warning"
                                                              @click="openWxUserList(item)" style="margin-top: 5px;">查看粉丝
                                                          </el-button>&ndash;&gt;
                                                          <el-button
                                                              size="mini"
                                                              type="warning"
                                                              @click="editAgent(item)" style="margin-top: 5px;">修改代理
                                                          </el-button>
                                                        </td>-->
                          </tr>
                          </tbody>
                        </table>
                        <Pagination
                            ref="Pagination"
                            :total-items="totalCount"
                            @page-change="pageChange"
                        ></Pagination>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <!-- 用户的弹窗 -->
    <el-dialog v-if="wxShopUserVisible" :close-on-click-modal="false" :visible.sync="wxShopUserVisible" title="查看粉丝"
               width="80%">
      <el-table
          :data="tableData"
          style="width: 100%">
        <el-table-column
            label="编号"
            prop="id"
            width="80">
        </el-table-column>
        <el-table-column
            label="昵称"
            prop="name"
            width="150">
        </el-table-column>
        <el-table-column
            label="手机号"
            prop="tel"
            width="180">
        </el-table-column>
        <el-table-column
            label="上级编号"
            prop="bindId"
            width="100">
        </el-table-column>
        <el-table-column
            label="消费积分"
            prop="score"
            width="100">
        </el-table-column>
        <el-table-column
            label="会员佣金"
            width="100">
          <template slot-scope="{row}">
            {{ row.userScore || 0 }}
          </template>
        </el-table-column>
        <el-table-column
            label="消费金额"
            prop="orderTotalMoney"
            width="100">
        </el-table-column>
        <el-table-column
            label="订单总数"
            prop="orderCount"
            width="100">
        </el-table-column>
        <el-table-column
            width="150"
            label="等级">
          <template slot-scope="scope">
            <el-tag
                v-if="scope.row.level === 1"
                disable-transitions
                type="info">小程序用户
            </el-tag>
            <el-tag
                v-if="scope.row.level === 2"
                disable-transitions
                type="warning">普通会员
            </el-tag>
            <el-tag
                v-if="scope.row.level === 3"
                disable-transitions
                type="success">推广使者
            </el-tag>
            <el-tag
                v-if="scope.row.level === 4"
                disable-transitions
                type="success">推广大使
            </el-tag>
            <el-tag
                v-if="scope.row.level === 5"
                disable-transitions
                type="success">领读者
            </el-tag>
            <el-tag
                v-if="scope.row.level === 6"
                disable-transitions
                type="success">领行者
            </el-tag>
            <el-tag
                v-if="scope.row.level === 7"
                disable-transitions
                type="success">领航者
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
            label="注册时间"
            prop="crTime"
            width="150">
        </el-table-column>
        <el-table-column
            label="操作">
          <template slot-scope="scope">
            <el-button
                size="mini"
                type="success"
                @click="openWxUserListTwo(scope.row)">查看粉丝
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="display: flex;justify-content: center;margin-top: 20px">
        <el-pagination
            :current-page="wxUserParams.current"
            :page-size="wxUserParams.size"
            :page-sizes="[10, 20, 30, 40]"
            :total="tableDataTotal"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </el-dialog>


    <!-- 用户的弹窗 -->
    <el-dialog v-if="wxShopUserVisibleTwo" :close-on-click-modal="false" :visible.sync="wxShopUserVisibleTwo"
               title="查看粉丝"
               width="80%">
      <el-table
          :data="tableDataTwo"
          style="width: 100%">
        <el-table-column
            label="编号"
            prop="id"
            width="80">
        </el-table-column>
        <el-table-column
            label="昵称"
            prop="name"
            width="150">
        </el-table-column>
        <el-table-column
            label="手机号"
            prop="tel"
            width="180">
        </el-table-column>
        <el-table-column
            label="上级编号"
            prop="bindId"
            width="100">
        </el-table-column>
        <el-table-column
            label="消费积分"
            prop="score"
            width="100">
        </el-table-column>
        <el-table-column
            label="会员佣金"
            width="100">
          <template slot-scope="{row}">
            {{ row.userScore || 0 }}
          </template>
        </el-table-column>
        <el-table-column
            label="消费金额"
            prop="orderTotalMoney"
            width="100">
        </el-table-column>
        <el-table-column
            label="订单总数"
            prop="orderCount"
            width="100">
        </el-table-column>
        <el-table-column
            width="150"
            label="等级">
          <template slot-scope="scope">
            <el-tag
                v-if="scope.row.level === 1"
                disable-transitions
                type="info">小程序用户
            </el-tag>
            <el-tag
                v-if="scope.row.level === 2"
                disable-transitions
                type="warning">普通会员
            </el-tag>
            <el-tag
                v-if="scope.row.level === 3"
                disable-transitions
                type="success">推广使者
            </el-tag>
            <el-tag
                v-if="scope.row.level === 4"
                disable-transitions
                type="success">推广大使
            </el-tag>
            <el-tag
                v-if="scope.row.level === 5"
                disable-transitions
                type="success">领读者
            </el-tag>
            <el-tag
                v-if="scope.row.level === 6"
                disable-transitions
                type="success">领行者
            </el-tag>
            <el-tag
                v-if="scope.row.level === 7"
                disable-transitions
                type="success">领航者
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
            label="注册时间"
            prop="crTime"
            width="150">
        </el-table-column>
        <!--        <el-table-column
                    label="操作">
                  <template slot-scope="scope">
                    <el-button
                        size="mini"
                        type="success"
                        @click="openWxUserListTwo(scope.row)">查看粉丝
                    </el-button>
                  </template>
                </el-table-column>-->
      </el-table>
      <div style="display: flex;justify-content: center;margin-top: 20px">
        <el-pagination
            :current-page="wxUserParamsTwo.current"
            :page-size="wxUserParamsTwo.size"
            :page-sizes="[10, 20, 30, 40]"
            :total="tableDataTotalTwo"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChangeTwo"
            @current-change="handleCurrentChangeTwo">
        </el-pagination>
      </div>
    </el-dialog>


    <el-dialog v-if="wxShopScoreVisible" :close-on-click-modal="false" :visible.sync="wxShopScoreVisible"
               title="佣金记录"
               width="50%">

      <el-table
          :data="wxUserScoreTableData"
          style="width: 100%">
        <el-table-column
            label="状态"
            width="180">
          <template slot-scope="scope">
            <p v-if="scope.row.type == 1">订单分佣</p>
            <p v-if="scope.row.type == 2">订单分佣</p>
            <p v-if="scope.row.type == 3">后台调整(增加)</p>
            <p v-if="scope.row.type == 4">提现扣除</p>
            <p v-if="scope.row.type == 5">转换余额</p>
            <p v-if="scope.row.type == 6">提现退回</p>
            <p v-if="scope.row.type == 7">后台调整(减少)</p>
          </template>
        </el-table-column>
        <el-table-column
            label="佣金"
            prop="score">
        </el-table-column>
        <el-table-column
            label="处理时间"
            prop="crTime">
        </el-table-column>
        <el-table-column
            label="关联订单"
            prop="orderId">
        </el-table-column>
      </el-table>
      <div style="display: flex;justify-content: center;margin-top: 20px">
        <el-pagination
            :current-page="wxUserScoreParams.current"
            :page-size="wxUserScoreParams.size"
            :page-sizes="[10, 20, 30, 40]"
            :total="wxShopUserScoreTotal"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChangeScore"
            @current-change="handleCurrentChangeScore">
        </el-pagination>
      </div>
    </el-dialog>

    <el-dialog v-if="wxShopUserScoreVisible" :close-on-click-modal="false" :visible.sync="wxShopUserScoreVisible"
               title="积分记录"
               width="50%">

      <el-table
          :data="wxUserScoreTableData"
          style="width: 100%">
        <el-table-column
            label="状态"
            width="180">
          <template slot-scope="scope">
            <p v-if="scope.row.type == 1">阅读商学院</p>
            <p v-if="scope.row.type == 2">后台调整(增加)</p>
            <p v-if="scope.row.type == 3">购物消耗</p>
            <p v-if="scope.row.type == 4">后台调整(减少)</p>
          </template>
        </el-table-column>
        <el-table-column
            label="积分"
            prop="score">
        </el-table-column>
        <el-table-column
            label="处理时间"
            prop="crTime">
        </el-table-column>
        <el-table-column
            label="关联订单"
            prop="orderId">
        </el-table-column>
      </el-table>
      <div style="display: flex;justify-content: center;margin-top: 20px">
        <el-pagination
            :current-page="wxUserScoreParams.current"
            :page-size="wxUserScoreParams.size"
            :page-sizes="[10, 20, 30, 40]"
            :total="wxShopUserScoreTotal"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChangeScore"
            @current-change="handleCurrentChangeScore">
        </el-pagination>
      </div>
    </el-dialog>

    <el-dialog v-if="editLevelVisible" :close-on-click-modal="false" :visible.sync="editLevelVisible"
               title="修改会员等级"
               width="20%">

      <div style="display: flex;justify-content: center;margin-top: 10px">

        <el-select v-model.number="level" placeholder="请选择">
          <el-option
              :value="1"
              label="小程序用户">
          </el-option>
          <el-option
              :value="2"
              label="队长">
          </el-option>
          <el-option
              :value="5"
              label="总队长">
          </el-option>
          <el-option
              :value="3"
              label="店长">
          </el-option>
          <el-option
              :value="4"
              label="老板">
          </el-option>
          <el-option
              :value="-1"
              label="金牌合伙人">
          </el-option>
        </el-select>
      </div>
      <div style="display: flex;justify-content: center;margin-top: 20px">
        <el-button type="primary" @click="updateLevel">确定</el-button>
      </div>

    </el-dialog>
    <el-dialog v-if="editStatusVisible" :close-on-click-modal="false" :visible.sync="editStatusVisible"
               title="修改账户状态"
               width="20%">

      <div style="display: flex;justify-content: center;margin-top: 10px">

        <el-select v-model.number="status" placeholder="请选择">
          <el-option
              :value="1"
              label="正常">
          </el-option>
          <el-option
              :value="2"
              label="封禁">
          </el-option>
        </el-select>
      </div>
      <div style="display: flex;justify-content: center;margin-top: 20px">
        <el-button type="primary" @click="updateStatus">确定</el-button>
      </div>

    </el-dialog>


    <el-dialog v-if="editAgentVisible" :close-on-click-modal="false" :visible.sync="editAgentVisible"
               title="修改代理等级"
               width="20%">

      <div style="display: flex;justify-content: center;margin-top: 10px">

        <el-select v-model.number="agent" placeholder="请选择">
          <el-option
              :value="1"
              label="省代">
          </el-option>
          <el-option
              :value="2"
              label="市代">
          </el-option>
          <el-option
              :value="3"
              label="区代">
          </el-option>
        </el-select>
      </div>
      <div style="display: flex;justify-content: center;margin-top: 20px">
        <el-button type="primary" @click="updateAgent">确定</el-button>
      </div>

    </el-dialog>

    <!--修改积分-->
    <el-dialog v-if="editScoreVisible" :close-on-click-modal="false" :visible.sync="editScoreVisible"
               title="修改用户积分"
               width="20%">

      <el-form ref="scoreForm" :model="scoreForm" :rules="rules" label-position="top" label-width="100px">
        <el-form-item label="调整类型" prop="scoreType" style="margin: 0 auto;width: 80%">
          <el-select v-model="scoreForm.scoreType" placeholder="调整类型" style="width: 100%">
            <el-option
                :value="1"
                label="增加积分">
            </el-option>
            <el-option
                :value="2"
                label="减少积分">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="积分" prop="userScore" style="margin: 0 auto;width: 80%">
          <el-input v-model="scoreForm.userScore"></el-input>
        </el-form-item>
      </el-form>
      <div style="display: flex;justify-content: center;margin-top: 20px">
        <el-button type="primary" @click="updateNewUserScore()">确定</el-button>
      </div>

    </el-dialog>

    <!--修改佣金-->
    <el-dialog v-if="editMoneyVisible" :close-on-click-modal="false" :visible.sync="editMoneyVisible"
               title="修改用户佣金"
               width="20%">

      <el-form ref="moneyForm" :model="moneyForm" :rules="rulesMoney" label-position="top" label-width="100px">
        <el-form-item label="调整类型" prop="moneyType" style="margin: 0 auto;width: 80%">
          <el-select v-model="moneyForm.moneyType" placeholder="调整类型" style="width: 100%">
            <el-option
                :value="1"
                label="增加佣金">
            </el-option>
            <el-option
                :value="2"
                label="减少佣金">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="佣金" prop="userMoney" style="margin: 0 auto;width: 80%">
          <el-input v-model="moneyForm.userMoney"></el-input>
        </el-form-item>
      </el-form>
      <div style="display: flex;justify-content: center;margin-top: 20px">
        <el-button type="primary" @click="updateNewUserMoney()">确定</el-button>
      </div>

    </el-dialog>


  </div>
</template>

<script>
import sd from "silly-datetime";
import {
  exportUserExcel,
  getBindWxUserTelApi, getShopUserPageApi, getWxScoreApi,
  getWxUserCountApi,
  getWxUserPageApi,
  getWxUserScoreApi, updateScoreApi,
  updateUserLevelApi,
  updateUserScoreApi, updateUserAgentApi, userUnbind, updateUserScoreNewApi, updateUserMoneyNewApi, userUpdateStatusApi
} from "@/api/WxUserApi";
import {updateIsShowApi} from "@/api/goodsManageApi";
import Index from "@/views/Shop/index.vue";
import {copySystemWxShop} from "@/api/shopApi";


export default {
  name: "",
  components: {
    Index
  },
  // 组件的props定义,用于子组件接收父组件传值
  // 组件的data属性
  data() {
    return {

      scoreForm: {
        scoreUserId: "",
        scoreType: "",
        userScore: "",
      },

      rules: {
        scoreType: [
          {required: true, message: '请选择调整类型', trigger: 'change'}
        ],
        userScore: [
          {required: true, message: '输入调整积分', trigger: 'blur'},
        ],
      },
      moneyForm: {
        moneyUserId: "",
        moneyType: "",
        userMoney: "",
      },

      rulesMoney: {
        moneyType: [
          {required: true, message: '请选择调整类型', trigger: 'change'}
        ],
        userMoney: [
          {required: true, message: '输入调整佣金', trigger: 'blur'},
        ],
      },
      params: {
        current: 1,
        size: 10,
        tel: "",
        name: "",
        cardId: "",
        cardPassword: "",
        status: "",
        level: "",
        userId: "",
        pUserId: "",
        agent: "",

      },
      list: [],
      loading: false,
      dialogVisible: false,
      totalCount: 0,

      wxShopScoreVisible: false,
      wxUserScoreTableData: [],
      wxUserScoreParams: {
        current: 1,
        size: 10,
        userId: ""
      },
      wxShopUserScoreTotal: 0,
      wxShopUserScoreVisible: false,

      editLevelVisible: false,
      level: "",
      levelUserId: "",


      wxShopUserVisible: false,
      wxUserParams: {
        current: 1,
        size: 10,
        pUserId: '',
      },
      tableData: [],
      tableDataTotal: 0,

      wxShopUserVisibleTwo: false,
      wxUserParamsTwo: {
        current: 1,
        size: 10,
        pUserId: '',
      },
      tableDataTwo: [],
      tableDataTotalTwo: 0,


      editAgentVisible: false,
      agent: "",
      agentUserId: "",

      editScoreVisible: false,
      editMoneyVisible: false,
      editStatusVisible: false,
      status: "",
      statusUserId: "",
      permissionList: []

    };
  },
  // 组件的方法
  methods: {

    toggleDropdown(index) {
      this.$nextTick(() => {
        const dropdown = document.getElementById(`dropdown-${index}`);
        new KTMenu(dropdown);
      });
    },

    openWxUserList(row) {
      this.getWxShopUserList(row)
      this.wxShopUserVisible = true
    },

    async getWxShopUserList(row) {
      this.wxUserParams.pUserId = row.id
      // let {data} = await getShopUserPageApi(this.wxUserParams)
      let {data} = await getWxUserPageApi(this.wxUserParams)
      this.tableData = data.rows
      this.tableDataTotal = data.total
    },

    handleSizeChange(val) {
      this.wxUserParams.size = val
      this.getWxShopUserList()
    },
    handleCurrentChange(val) {
      this.wxUserParams.current = val
      this.getWxShopUserList()
    },

    openWxUserListTwo(row) {
      this.getWxShopUserListTwo(row)
      this.wxShopUserVisibleTwo = true
    },

    async getWxShopUserListTwo(row) {
      this.wxUserParamsTwo.pUserId = row.id
      // let {data} = await getShopUserPageApi(this.wxUserParams)
      let {data} = await getWxUserPageApi(this.wxUserParamsTwo)
      this.tableDataTwo = data.rows
      this.tableDataTotalTwo = data.total
    },

    handleSizeChangeTwo(val) {
      this.wxUserParamsTwo.size = val
      this.getWxShopUserListTwo()
    },
    handleCurrentChangeTwo(val) {
      this.wxUserParamsTwo.current = val
      this.getWxShopUserListTwo()
    },

    pageChange(currentPage, pageSize) {
      this.params.current = currentPage;
      this.params.size = pageSize;
      this.getList();
    },
    async getList() {
      this.loading = true
      let {data} = await getWxUserPageApi(this.params)
      this.list = data.rows
      this.loading = false
      this.totalCount = data.total
    },
    resetBtn() {
      this.params = {
        current: 1,
        size: 10,
        tel: "",
        name: "",
        cardId: "",
        cardPassword: "",
        status: "",
        level: "",
        userId: "",
        pUserId: "",
        agent: "",

      };
      this.getList();
    },

    handleEditScore(row) {
      /* this.$prompt('请输入要修改的佣金', '提示', {
         confirmButtonText: '确定',
         cancelButtonText: '取消',
         inputPattern: /^[0-9]\d*(\.\d+)?$/,
         inputErrorMessage: '佣金格式不正确',
         inputValue: row.userScore
       }).then(({value}) => {
         this.updateScore(row.id, value)
       }).catch(() => {
         this.$message({
           type: 'info',
           message: '取消输入'
         });
       });*/

      this.moneyForm.moneyUserId = row.id
      this.editMoneyVisible = true
    },

    async updateScore(userId, score) {
      await updateScoreApi({userId, score})
      this.$message.success("修改成功")
      this.getList()
    },

    checkUserScore(row) {
      this.wxShopScoreVisible = true
      this.wxUserScoreTableData = []
      this.wxUserScoreParams.current = 1
      this.wxUserScoreParams.size = 10
      this.wxUserScoreParams.userId = row.id
      this.getWxScore();
    },

    async getWxScore() {
      let {data} = await getWxScoreApi(this.wxUserScoreParams)
      this.wxUserScoreTableData = data.rows
      this.wxShopUserScoreTotal = data.total
    },

    handleEdit(row) {
      /*this.$prompt('请输入要修改的积分', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^[0-9]\d*(\.\d+)?$/,
        inputErrorMessage: '积分格式不正确',
        inputValue: row.score
      }).then(({value}) => {
        this.updateUserScore(row.id, value)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        });
      });*/


      this.scoreForm.scoreUserId = row.id
      this.editScoreVisible = true
    },

    async updateUserScore(userId, score) {
      await updateUserScoreApi({userId, score})
      this.$message.success("修改成功")
      this.getList()
    },

    checkScore(row) {
      this.wxUserScoreTableData = []
      this.wxUserScoreParams.current = 1
      this.wxUserScoreParams.size = 10
      this.wxUserScoreParams.userId = row.id
      this.getWxUserScore();
      this.wxShopUserScoreVisible = true
    },

    async getWxUserScore() {
      let {data} = await getWxUserScoreApi(this.wxUserScoreParams)
      this.wxUserScoreTableData = data.rows
      this.wxShopUserScoreTotal = data.total
    },
    editLevel(row) {
      this.level = row.level
      this.levelUserId = row.id
      this.editLevelVisible = true
    },
    editStatus(row) {
      this.status = row.status
      this.statusUserId = row.id
      this.editStatusVisible = true
    },
    async updateStatus(){
      await userUpdateStatusApi({userId:this.statusUserId,status:this.status})
      this.$message.success("修改成功")
      this.editStatusVisible = false
      this.getList()
    },
    async updateLevel() {
      await updateUserLevelApi({userId: this.levelUserId, level: this.level})
      this.$message.success("修改成功")
      this.editLevelVisible = false
      this.getList()
    },

    editAgent(row) {
      this.agent = row.agent
      this.agentUserId = row.id
      this.editAgentVisible = true
    },
    async updateAgent() {
      await updateUserAgentApi({userId: this.agentUserId, agent: this.agent})
      this.$message.success("修改成功")
      this.editAgentVisible = false
      this.getList()
    },

    jiebang(row) {

      this.$confirm(`你确定解绑 `, `是否继续?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        dangerouslyUseHTMLString: true,
        type: "warning",
      }).then(async () => {
        await userUnbind({userId: row.id}
        );
        this.$message({
          type: "success",
          message: "解绑成功!",
        });
        this.getList();
      }).catch(() => {
      });

    },

    updateNewUserScore() {
      this.$refs.scoreForm.validate(async (valid) => {
        if (valid) {
          await updateUserScoreNewApi(this.scoreForm)
          this.$message.success("修改成功")
          this.editScoreVisible = false
          this.getList()

        } else {
          return false
        }
      });
    },

    updateNewUserMoney() {
      this.$refs.moneyForm.validate(async (valid) => {
        if (valid) {
          await updateUserMoneyNewApi(this.moneyForm)
          this.$message.success("修改成功")
          this.editMoneyVisible = false
          this.getList()

        } else {
          return false
        }
      });
    },

  },
  // 在created钩子中执行的操作
  created() {
    this.getList();
    this.permissionList = this.$store.state.user.permissionList
  },

  updated() {
    // 当数据更新后，可以在此处手动初始化下拉菜单插件
    this.rows.forEach((_, index) => {
      this.toggleDropdown(index);
    });
  },
  filters: {
    dataFormat(date) {
      return sd.format(date, "YYYY-MM-DD HH:mm:ss");
    },
    format(num) {
      return (
          Number(num)
              .toFixed(2)
              .replace(/\d(?=(\d{3})+\.)/g, "$&,") + " 元"
      );
    },
  },
};
</script>

<!-- 组件的样式 -->
<style scoped>
.el-range-separator {
  padding: 0;
}


.messageIndex {
  z-index: 9999 !important;
}
</style>
